import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import Onboarding from "@/components/molecules/OnBoarding.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BeginnerIconOnboarding',
  setup(__props) {

const beginnersCatPath = require("@/assets/img/onboarding/beginners-cat.webp");
const closeIconImagePath = require("@/assets/img/onboarding/close_icon.png");

const isVisible = ref(true);

const message = computed(
  () => `
  <div
    style="
      position: relative;
      text-align: center;
      font-size: 14px;
      line-height: 1.1;
      margin-bottom: 16px;
      font-weight: normal;
    "
  >
    <div
      class="close-button"
      style="
        position: absolute;
        right: 0px;
        top: -5px;
        cursor: pointer;
        text-align: center;
      "
    >
      <img
        src="${closeIconImagePath}"
        style="width: 22px; height: auto; display: block; margin: 0 auto"
      />
    </div>
    <div style="margin-bottom: 10px">
      <img
        src="${beginnersCatPath}"
        style="width: 70px; height: auto"
      />
    </div>
    <style>
    .centered-text {
      text-align: left;
      margin: 0 auto;
      line-height: 1.5;
      max-width: 95%;
    }
    </style>
    <div class="centered-text">
      「Nolaの使いかたガイド」をご覧くださり、ありがとうございました。次回から、<strong>右上の初心者マーク</strong
      >よりご覧いただけます。必要に応じて、ぜひご活用ください🐈‍⬛
    </div>
  </div>
  <style>
    .close-link {
      display: inline-block;
      font-size: 13px;
      color: #909090;
      text-decoration: underline;
      cursor: pointer;
    }
    .close-link:hover {
      color: #707070;
    }
  </style>
  <div style="text-align: center">
    <span
      class="close-link"
    >
      閉じる
    </span>
  </div>
`
);

// 閉じる処理
function closeOnboarding() {
  isVisible.value = false;
}

// DOM の準備完了後にイベントリスナーを登録
onMounted(() => {
  const closeButton = document.querySelector(".close-button");
  closeButton?.addEventListener("click", closeOnboarding);

  const closeLink = document.querySelector(".close-link");
  closeLink?.addEventListener("click", closeOnboarding);
});

return { __sfc: true,beginnersCatPath, closeIconImagePath, isVisible, message, closeOnboarding, Onboarding }
}

})